import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { StatusStore } from "./types";

export const useStatusStore = create<StatusStore>()(
  persist(
    (set, get) => ({
      statuses: {},
      getStatuses: () => {
        return get().statuses;
      },
      setStatuses: (statuses) => {
        set({ statuses });
      },
      clearStatuses: () => {
        set({ statuses: {} });
      },
    }),
    {
      name: "api-status-store",
    },
  ),
);
